import { FINAL_RUNG, JOURNEY_RUNGS } from '@lexicon/core';
import { useStrings } from '../state/AppContext';

export interface JourneyProgressProps {
  /** The rung being played, or — after a finish — the one coming next. */
  rung: number;
  bestRung: number;
  journeysCompleted: number;
  /** Renders the completion line above the pips. */
  complete?: boolean;
}

const PIP = 'grid h-6 w-6 place-items-center rounded-full border text-[11px] font-bold';

export function JourneyProgress({ rung, bestRung, journeysCompleted, complete = false }: JourneyProgressProps) {
  const t = useStrings();
  return (
    <div className="flex flex-col gap-1" role="group" aria-label={t.journey.rungLabel(rung, FINAL_RUNG)}>
      {complete ? (
        <p className="text-sm font-semibold text-accent">{t.journey.complete}</p>
      ) : null}
      <div className="flex items-center gap-1.5">
        {JOURNEY_RUNGS.map((n) => (
          <span
            key={n}
            aria-hidden="true"
            className={[
              PIP,
              n === rung ? 'border-transparent bg-grad-accent text-white'
                : n < rung ? 'border-accent text-accent'
                  : 'border-hairline text-dim',
            ].join(' ')}
          >
            {n}
          </span>
        ))}
        {journeysCompleted > 0 ? (
          <span className="ml-1 whitespace-nowrap text-[10px] text-dim">{t.journey.completedCount(journeysCompleted)}</span>
        ) : null}
        {bestRung > rung ? (
          <span className="ml-auto whitespace-nowrap text-[10px] text-dim">{t.journey.best(bestRung)}</span>
        ) : null}
      </div>
    </div>
  );
}
